import { createClient } from '@supabase/supabase-js'
import { readSupabaseEnv } from './env'

/**
 * Client Supabase unique de l'application.
 *
 * Cle publiable uniquement : toute lecture et toute ecriture passent par les
 * policies RLS. Aucune cle secrete ne doit apparaitre dans `src/` — elle vit
 * dans les Edge Functions et les secrets de CI. Les motifs interdits sont
 * listes dans scripts/check-no-secrets.sh, et volontairement absents d'ici.
 */
const { url, publishableKey } = readSupabaseEnv(import.meta.env)

export const supabase = createClient(url, publishableKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
})
